import { Component, ErrorHandler, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import swal from 'sweetalert2';
import { UserService } from '../../../../shared/user.service';

@Component({
  selector: 'app-disciplineform',
  templateUrl: './disciplineform.component.html',
  styleUrls: ['./disciplineform.component.css']
})
export class DisciplineformComponent implements OnInit {
title =  'Discipline Details';
  data: any;
  CD_Id: number;
  D: any = {};
  mode: any;

constructor(private userService: UserService, private router: Router, private route: ActivatedRoute, private errorHandler: ErrorHandler,) { }
  ngOnInit() {
    this.route.params.subscribe(params => {
      this.CD_Id = params['CD_Id'];
      this.mode = params['mode'];

      if (this.CD_Id > 0) {

        this.GetByIdClinicalDiscipline(this.CD_Id)
      }
    });
    if (this.mode == 'View') {
      this.title = "View Discipline ";
    }
    else if (this.mode == 'Edit') {
      this.title = "Edit Discipline ";
    }
  }

  CreateDiscipline(Discipline: NgForm) {
    debugger;
    this.data = this.userService.CreateDiscipline(Discipline.value);
    this.data.subscribe(
      (response) => {
        Discipline.reset();
        Discipline.resetForm();
        Discipline.form.markAsPristine();
        Discipline.form.markAsUntouched();
        swal('Success!', 'Discipline Details Added Successfully .', 'success');
        this.router.navigate(['/home/discipline']);
      }, (error) => {
        if (error.status == 401) {
          this.errorHandler.handleError(error);
        }
        else if (error.status == 400) {
          swal('Warning!', error.error.Message, 'warning');
        }
      });
  }

  GetByIdClinicalDiscipline(CD_Id) {
    debugger;
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.userService.GetByIdClinicalDiscipline(CD_Id);
    this.data.subscribe(
      (response: any) => {
        this.D = response;
      }, (error) => {
      });
  }

  UpdateDiscipline(Discipline: NgForm) {
    debugger;
    this.data = this.userService.UpdateDiscipline(this.CD_Id,Discipline.value);
    this.data.subscribe(
      (response) => {
        swal('Success!', ' Discipline details updated Successfully .', 'success');
        this.router.navigate(['/home/discipline']);
      }, (error) => {
        if (error.status == 401) {
          this.errorHandler.handleError(error);
        }
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/Pages/manage/discipline/disciplineform/disciplineform.component.ts